export type DemoLinkSummary = {
  token: string;
  isEnabled: boolean;
};

export function pickEnabledDemoToken(links: DemoLinkSummary[]): string | null {
  const enabled = links.find((link) => link.isEnabled && link.token.trim());
  return enabled?.token ?? null;
}

type LocationLike = {
  protocol: string;
  hostname: string;
  port: string;
};

/** Origen de la consola (agents.*), donde vive el chat de test `/demo/:token`. */
export function consoleAppOrigin(loc: LocationLike, envOrigin?: string): string {
  const explicit = envOrigin?.trim();
  if (explicit) return explicit.replace(/\/$/, '');
  const host = loc.hostname.toLowerCase();
  if (host.startsWith('pwa.')) {
    const port = loc.port ? `:${loc.port}` : '';
    return `${loc.protocol}//agents.${host.slice(4)}${port}`;
  }
  if ((host === 'localhost' || host === '127.0.0.1') && loc.port === '3012') {
    return `${loc.protocol}//${loc.hostname}:3011`;
  }
  const port = loc.port ? `:${loc.port}` : '';
  return `${loc.protocol}//${loc.hostname}${port}`;
}

/** Cada `fresh` cambia la URL para forzar una recarga y una conversación nueva. */
export function agentDemoTestUrl(
  origin: string,
  token: string,
  fresh: number | string,
  testPass?: string,
): string {
  const base = origin.replace(/\/$/, '');
  const params = new URLSearchParams({ fresh: String(fresh) });
  if (testPass) params.set('test', testPass);
  return `${base}/demo/${encodeURIComponent(token)}?${params.toString()}`;
}
